export default class BackofficeUpgradeRequestsIndex {
  constructor() {
    this.initDataTables();
    this.bindEvents();
  }

  initDataTables() {
    // Table des upgrades
    if ($('#upgrades-table').length > 0) {
      this.upgradesTable = $('#upgrades-table').DataTable({
        responsive: true,
        stateSave: false,
        order: [[5, "desc"]], // Trier par date de demande décroissante
        columnDefs: [
          {
            targets: [7], // Actions column
            orderable: false
          }
        ],
        language: {
          url: '/assets/data-tables/locales/' + I18n.locale + '.json'
        },
        drawCallback: function() {
          $(".dataTables_paginate > .pagination").addClass("pagination-rounded");
        }
      });
    }

    // Table des downgrades
    if ($('#downgrades-table').length > 0) {
      this.downgradesTable = $('#downgrades-table').DataTable({
        responsive: true,
        stateSave: false,
        order: [[5, "desc"]], // Trier par date de demande décroissante
        columnDefs: [
          {
            targets: [7], // Actions column
            orderable: false
          }
        ],
        language: {
          url: '/assets/data-tables/locales/' + I18n.locale + '.json'
        },
        drawCallback: function() {
          $(".dataTables_paginate > .pagination").addClass("pagination-rounded");
        }
      });
    }

    // Table de l'historique
    if ($('#processed-requests-table').length > 0) {
      this.historyTable = $('#processed-requests-table').DataTable({
        responsive: true,
        stateSave: false,
        order: [[8, "desc"]], // Trier par date de traitement décroissante
        columnDefs: [
          {
            targets: [10], // Actions column
            orderable: false
          }
        ],
        language: {
          url: '/assets/data-tables/locales/' + I18n.locale + '.json'
        },
        drawCallback: function() {
          $(".dataTables_paginate > .pagination").addClass("pagination-rounded");
        }
      });
    }
  }

  bindEvents() {
    // Event pour les modals de détails
    $('#reasonModal').on('show.bs.modal', (event) => {
      const button = $(event.relatedTarget);
      const reason = button.data('reason');
      const service = button.data('service');
      const productChange = button.data('product-change');
      const requestType = button.data('request-type');
      
      const modal = $(event.target);
      modal.find('#modal-service-number').text(service);
      modal.find('#modal-reason-text').html(reason.replaceAll('\n', '<br>'));
      const formattedChange = productChange ? productChange.toString().replaceAll(/\s\|\s/g, '<br>') : 'N/A';
      modal.find('#modal-product-change').html(`${requestType}<br>${formattedChange}`);
    });

    // Tooltips
    $('[data-toggle="tooltip"]').tooltip();

    // Counter animation
    $('[data-plugin="counterup"]').each(function() {
      const element = $(this);
      const target = Number.parseInt(element.text()) || 0;
      element.text('0');
      
      const duration = 2000;
      const stepTime = Math.abs(Math.floor(duration / target));
      
      let current = 0;
      const increment = target > stepTime ? target / stepTime : 1;
      
      const timer = setInterval(() => {
        current += increment;
        if (current >= target) {
          current = target;
          clearInterval(timer);
        }
        element.text(Math.floor(current));
      }, stepTime);
    });
  }

  onDestroy() {
    // Nettoyer les DataTables
    if (this.upgradesTable) {
      this.upgradesTable.destroy();
    }
    if (this.downgradesTable) {
      this.downgradesTable.destroy();
    }
    if (this.historyTable) {
      this.historyTable.destroy();
    }

    // Nettoyer les événements
    $('#reasonModal').off('show.bs.modal');
    $('[data-toggle="tooltip"]').tooltip('dispose');
  }
}